import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { identity as parse } from 'lodash';
import React, { useEffect } from 'react';
import { useField, useForm } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { DepositPayload } from '../../../../types/Cashier';
import type { BonusTab } from '../../BonusOffer';
import CRMBonus from '../CRMBonus/CRMBonus';
import OwnBonusCode from '../OwnBonusCode/OwnBonusCode';

import {
  TXTWCL_Or_enter_your_own_code,
  TXTWCL_Select_your_welcome_bonus
} from './BonusCards.messages.json';
//
// TODO: use `<hr />` instead of delimiter. If required define the style in Page.scss or create <Delimiter /> but not like this.
import { crmBonus, delimeter, ownBonus } from './BonusCards.scss';

interface Props {
  selectedTab?: BonusTab;
  setSelectedTab(tab: BonusTab): void;
}

const fieldName = 'deposit.bonusCode';

const BonusCards: React.FC<Props> = ({ selectedTab, setSelectedTab }) => {
  const {
    data: { crmBonusCode },
    values: { deposit }
  } = useWizardContext();
  const isSwcAffiliateBonusEnabled = useFeature(FeatureFlag.SwcAffiliateBonus);

  const {
    input: { onChange }
  } = useField(fieldName, { subscription: { value: true }, parse });

  const form = useForm();

  useEffect(() => {
    let bonusCode: DepositPayload['bonusCode'];

    if (selectedTab === 'crmBonus') {
      bonusCode = crmBonusCode;
    } else {
      if (!deposit || deposit.bonusCode === crmBonusCode || !selectedTab) {
        form.change(fieldName, undefined);
        delete deposit?.bonusCode;
        return;
      } else {
        bonusCode = deposit.bonusCode as string;
      }
    }

    onChange(bonusCode);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  useEffect(() => {
    if (!crmBonusCode && isSwcAffiliateBonusEnabled) {
      setSelectedTab('ownBonus');
    }
  }, [isSwcAffiliateBonusEnabled, crmBonusCode, setSelectedTab]);

  return (
    <>
      {!!crmBonusCode && (
        <>
          <Translation {...TXTWCL_Select_your_welcome_bonus} tagName="h3" />
          <fieldset className={crmBonus} onClick={() => setSelectedTab('crmBonus')}>
            <CRMBonus selected={selectedTab === 'crmBonus'} />
          </fieldset>
        </>
      )}
      {isSwcAffiliateBonusEnabled && (
        <>
          {!!crmBonusCode && (
            <div className={delimeter}>
              <span>
                <Translation {...TXTWCL_Or_enter_your_own_code} />
              </span>
            </div>
          )}
          <fieldset className={ownBonus} onClick={() => setSelectedTab('ownBonus')}>
            <OwnBonusCode selected={selectedTab === 'ownBonus'} />
          </fieldset>
        </>
      )}
    </>
  );
};

export default BonusCards;
